import * as React from "react";
import { Calendar } from "../../../components/atoms/Calendar";
import {
  UseStudentCalendarContainerProps,
  useStudentCalendarContainer,
} from "./useStudentCalendarContainer";

type Props = UseStudentCalendarContainerProps;

export const StudentCalendarContainer = (
  props: Props,
): React.ReactElement<any> => {
  const {
    isLoading,
    onChangeScheduleFromInteraction,
    events,
    onSelectFromSlot,
    eventColor,
    onClickSchedule,
    shouldShowPlaceHolderEvent,
  } = useStudentCalendarContainer(props);

  return (
    <Calendar
      events={isLoading ? [] : events}
      startDate={props.startDate}
      calendarType={props.calendarType}
      onSelectSlot={onSelectFromSlot}
      onClickSchedule={onClickSchedule}
      onEventResize={onChangeScheduleFromInteraction}
      onDropSchedule={onChangeScheduleFromInteraction}
      eventColor={eventColor}
      shouldShowPlaceHolderEvent={shouldShowPlaceHolderEvent}
    />
  );
};
